export const isTizen = (): boolean => {
  const ua = window.navigator.userAgent.toLowerCase()
  return typeof window.tizen !== 'undefined' || /tizen|samsung/.test(ua)
}
